module.exports = __webpack_public_path__ + "static/media/illustration-flowing-conversation.6641e825.svg";